// PM-suite left sub-rail. Three sections; icon + label per item, dark-fill
// active state. Lives INSIDE the /Projects page container — the global
// Menu is unchanged. Not a generic micro-app shell; this is just how the
// PM Suite happens to look.
//
// Section switching is now state-driven via `onSelect`. The parent owns
// the section state and decides whether (and how) to sync URLs — this
// component never calls into React Router itself, which avoids triggering
// IonRouterOutlet's page-transition logic on every sub-rail click (the
// intermittent "whole container goes blank" bug).

import { IconFolder, IconInbox, IconTemplate } from './Icons';

export type PmSection = 'projects' | 'mywork' | 'templates';

interface SectionDef {
  id: PmSection;
  label: string;
  // Path the parent uses when syncing the URL for deep linking. The rail
  // itself never navigates here; it just hands the id back via onSelect.
  path: string;
  Icon: React.FC<{ size?: number }>;
}

export const SECTIONS: SectionDef[] = [
  { id: 'projects',  label: 'Projects',  path: '/Projects',           Icon: IconFolder   },
  { id: 'mywork',    label: 'My work',   path: '/Projects/MyWork',    Icon: IconInbox    },
  { id: 'templates', label: 'Templates', path: '/Projects/Templates', Icon: IconTemplate },
];

interface Props {
  active: PmSection;
  onSelect: (id: PmSection) => void;
}

const SubRail: React.FC<Props> = ({ active, onSelect }) => {
  return (
    <nav className="pm-subrail" aria-label="PM sections">
      {SECTIONS.map((s) => {
        const isActive = s.id === active;
        return (
          <button
            key={s.id}
            type="button"
            className={`pm-subrail-item${isActive ? ' is-on' : ''}`}
            aria-current={isActive ? 'page' : undefined}
            onClick={() => onSelect(s.id)}
          >
            <span className="pm-subrail-icon"><s.Icon size={18} /></span>
            <span className="pm-subrail-label">{s.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default SubRail;
